import html from 'html-template-string';

const $bboxes = document.querySelectorAll('[href*="#bbox"]');
$bboxes.forEach(($bbox) => {
    let id = '';
    let otherID = '';
    if ($bbox.href.match(/#bbox-now/)) {
        id = $bbox.href.replace(/.*(#bbox-now-?)(.+)$/, '$2');
        otherID = '/donate-now/';
    } else {
        id = $bbox.href.replace(/.*(#bbox-?)(.+)$/, '$2');
    }
    // set up the click event
    $bbox.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo(0, 0);

        // show overlay and iframe
        const $overlay = html`
            <div class="Overlay" id="overlay-${id}" style="display: block; text-align: center;">
                <a href="${document.location.href}" class="Overlay__close">&times;</a>
                <iframe src="/home/bbox/${id}${otherID}" class="Overlay__iframe -bbox"></iframe>
            </div>
        `;

        // close on click
        $overlay.querySelector('.Overlay__close').addEventListener('click', (evt) => {
            evt.preventDefault();
            $overlay.parentNode.removeChild($overlay);
        });

        document.body.appendChild($overlay);
    });
});
